export default "<div *ngIf=\"displayError\">\n  <span class=\"error-msg\"> {{ errorMsg }} </span>\n</div>\n"